import { render, staticRenderFns } from "./expedientecambio.vue?vue&type=template&id=5ab955f8&scoped=true"
import script from "./expedientecambio.vue?vue&type=script&lang=js"
export * from "./expedientecambio.vue?vue&type=script&lang=js"
import style0 from "./expedientecambio.vue?vue&type=style&index=0&id=5ab955f8&prod&scoped=true&lang=css"
import style1 from "./expedientecambio.vue?vue&type=style&index=1&id=5ab955f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab955f8",
  null
  
)

export default component.exports